import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classes from './MoreCard.module.scss';
import { BackArrowIcon } from '@icons';
import classNames from 'classnames';
import { useTypedDispatch } from '@hooks/useTypedDispatch';
import { triggerMetricsEvent } from '@metrics';
import { useSelector } from 'react-redux';
import { isSafariSelector } from '@store/models/user/selectors';
import Picture from '@components/shared/Picture/Picture';
import { useWindowSize } from '@hooks/useWindowSize';
import { isSubscriptionActiveSelector } from '@store/models/subscription/selectors';
const MoreCard = ({ element }) => {
    const isSafari = useSelector(isSafariSelector);
    const { isDesktop } = useWindowSize();
    const cardClasses = classNames(classes.card, classes[element.name], {
        [classes.safari]: isSafari,
    });
    const { dialogModel: { openMoreElDialog }, } = useTypedDispatch();
    const handleClick = () => {
        openMoreElDialog(element.name);
        triggerMetricsEvent({ element: element.name });
    };
    const badge = isDesktop && element.icon.desktop ? element.icon.desktop : element.icon.mobile;
    const isSubscriptionActive = useSelector(isSubscriptionActiveSelector);
    const showPrice = !isSubscriptionActive;
    return (_jsxs("div", { className: cardClasses, onClick: handleClick, children: [_jsx(Picture, { src: badge.src, alt: badge.alt, className: classes.badge }), element.price && showPrice && _jsx("span", { className: classes.price, children: element.price }), _jsxs("div", { className: classes.titleBlock, children: [_jsx("h3", { className: classes.title, children: element.title }), isDesktop && (_jsx("span", { className: classes.arrowIconWrap, children: _jsx(BackArrowIcon, { containerClasses: classes.arrowIcon }) }))] })] }));
};
export default MoreCard;
